 
 import { useCatPresup } from "@/composables/useCatPresup";
  import store from "@/store";  
 
 export const agrupa_categorias_suma_presupuestos2 =  (presupuestos, storeStateCuentas) => {        
 
        if (!storeStateCuentas){
            storeStateCuentas =  store.state.cuentas.cuentas
        }


       let categorias_cuentas_totales=[]
       
        let array_presupuesto_categorias=[]
          /*          
         array de objetos 
         presupuestos:
              1) diferentes centro_id 
              2) diferenres cuenta_id  
              [
                {
                    "id": 107,
                    "centro_id": 8,
                    "categoria_id": 8,
                    "tipo_id": 16,
                    "cuenta_id": 78,
                    "empresa_id": 1,
                    "aa": 2026,
                    "moneda_id": 1,
                    "total_presupuesto": "50000.00",
                    "total_gastos": "0.00"
                },
                 
                ]
        
                  v/s   this.$store.state.cuentas.cuentas


                  [{
                    "id":112,
                    "codigo":"4.5.1030.80.44",
                    "nombre":"Alarma",
                    "tipo_cuenta":{
                        "id":13,
                        "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                        "categoria_cuenta":{
                            "id":8,
                            "nombre":"GASTOS GENERALES",
                            "orden": 3
                        }
                    }
              ]   
           
  
      */

         
         
     //  trae todas las cuentas coincidentes (plan de presupuestos v/s presupuestos creados )
     //  tengan o no movimientos
       
        const {getCatPresupV2}= useCatPresup()
        const {categorias,catctas} =getCatPresupV2(presupuestos,storeStateCuentas);
        categorias_cuentas_totales=categorias

      
        //console.log("cat&ctas",catctas)

/*

console.log('categorias',categorias_cuentas_totales)   
[
    {
        "id": 8,
        "nombre": "GASTOS GENERALES",
        "tipos": [
            {
                "id": 24,
                "nombre": "MEDICIONES y EVALUACIONES",
                "cuentas": [
                    {
                        "id": 79,
                        "cod": "4510308058",
                        "nomcta": "Informes Laboratorio",
                        "total_presupuesto": 1000,
                        "total_gastos": 0,
                        "saldo": 1000
                    }
                ]
            }
        ],
        "centros": [
            [
                {
                    "centro_id": 8,
                    "categoria_id": 8,
                    "total_presupuesto": "1000.00"
                }
            ]
        ],
        "orden": 3
    }
]
   

      */

        // ordenar por atributo 'orden'
        categorias_cuentas_totales = Object.values(categorias_cuentas_totales).sort((a, b) => 
          (a.orden ?? Infinity) -
          (b.orden ?? Infinity)
        );
        
        // categoria cuentas: sumar gastos y presupuestos de sus cuentas asociadas
        array_presupuesto_categorias = categorias_cuentas_totales.map(grupo => ({
            id:grupo.id,
            nombre: grupo.nombre,
            orden: grupo.orden,
            total_gastos:grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c?.total_gastos), 0),
            total_presupuesto:grupo.tipos.flatMap(t => t.cuentas).reduce((acc, c) => acc + Number(c?.total_presupuesto), 0),
            centros: grupo.centros
        }));
     
        console.log(array_presupuesto_categorias)
 

     
      
      return{ 
               
              'array_presupuesto_categorias':array_presupuesto_categorias,
              'array_detalle_centros':catctas
            } 
 }